/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getListMutes.defs.js'
export { main as default } from './getListMutes.defs.js'
